import { IconStar } from '@tabler/icons-react'
import { useI18n } from '../../lib/i18n'

/**
 * Ver sólo lo destacado, de un toque.
 *
 * El filtro ya existía dentro del menú de filtros, y ahí seguirá: quien abre ese
 * menú va a decidir varias cosas a la vez —qué se ve, cómo se ordena— y las
 * estrellas son una de ellas. Pero mirar los destacados no es configurar una
 * lista, es un vistazo, y en un vistazo un menú es un desvío: abrir, leer cinco
 * opciones, elegir una y volver.
 *
 * Va pegado al buscador porque hacen lo mismo: reducir la lista a lo que se
 * busca. Y comparte la forma del botón de filtros —mismo cuadro, mismo alto—
 * para que los tres se lean como una fila de mandos y no como tres piezas
 * sueltas.
 *
 * Es un interruptor, así que lo dice: `aria-pressed` y un estado encendido con
 * el ámbar de las propias estrellas. Un botón que se queda hundido sin que nada
 * cambie de color es la forma más rápida de que alguien crea que la lista está
 * vacía.
 */
export function StarFilterButton({ active, onToggle, label }: {
  active: boolean
  onToggle: () => void
  /** En plural y en el género que toque: «destacadas» para páginas. */
  label?: string
}) {
  const { t } = useI18n()
  const itemLabel = label ?? t('common.starred')
  return (
    <button
      type="button"
      className={`dash-filter-trigger dash-star-filter${active ? ' is-active' : ''}`}
      aria-label={active ? t('common.starFilter.viewAllAria', { label: itemLabel }) : t('common.starFilter.onlyAria', { label: itemLabel })}
      aria-pressed={active}
      data-tooltip={active ? t('common.starFilter.viewAll') : t('common.starFilter.only', { label: itemLabel })}
      onClick={onToggle}
    >
      <IconStar size={15} aria-hidden="true" />
    </button>
  )
}
